import React, { SVGProps } from 'react';

const SvgCustomToggleButtonOpen = (props: SVGProps<SVGSVGElement>) => (
    <svg 
        xmlSpace='preserve'  
        width="26" height="26" 
        viewBox="0 0 26 26" fill="none" 
        className='svg-icon'  {...props}  
        xmlns="http://www.w3.org/2000/svg">
    <rect x="25" y="25" width="24" height="24" rx="6.92375" transform="rotate(-180 25 25)" stroke="#4B4B4B" strokeWidth="1.94595"/>
    <path d="M13.8574 18.1426L19.0003 12.9997L13.8574 7.85687" stroke="#4B4B4B" strokeWidth="1.94595"/>
    <path d="M7 18.1426L12.1429 12.9997L7 7.85687" stroke="#4B4B4B" strokeWidth="1.94595"/>
    </svg>

);

export default SvgCustomToggleButtonOpen;